// Public API for util
export {Class, ClassDefinition, TypeDecorator} from './util/decorators';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
